import morphism, { StrictSchema } from 'morphism'
import dateToFedFormatFactory from 'tfs.front-end-utils/CSV/dateToFedFormatFactory'
import getGenderFromCSV from 'tfs.front-end-utils/CSV/getGenderFromCSV'

import constants from '../../config/constants'

import ServerUploadedPassengerInterface from '../../interfaces/server/UploadedPassenger'
import InfantPassengerInterface from '../../interfaces/client/InfantPassenger'

import uploadedInfantPassengerToInfantPassengerSchema from '../../schemas/client/uploadedInfantPassengerToInfantPassenger'

import { moment } from '../../utils/dates'
import generateUniqueId from '../../utils/generateUniqueId'

const dateToFedFormat = dateToFedFormatFactory(moment)

export const travelClass = () => constants.defaultTravelClass
export const id = () => generateUniqueId()
export const ssrs = () => []

export const gender = (passenger: ServerUploadedPassengerInterface) =>
  getGenderFromCSV(passenger.gender)

export const dateOfBirth = (passenger: ServerUploadedPassengerInterface) =>
  dateToFedFormat(passenger.dateOfBirth)

export const infant = (passenger: ServerUploadedPassengerInterface) => {
  if (
    !passenger.infantFirstName ||
    !passenger.infantLastName ||
    !passenger.infantDateOfBirth ||
    !passenger.infantGender
  ) {
    return undefined
  }

  return morphism<
    StrictSchema<InfantPassengerInterface, ServerUploadedPassengerInterface>
  >(uploadedInfantPassengerToInfantPassengerSchema, passenger)
}

export default {
  id,
  thirdPartyBookingNumber: 'bookingId',
  firstName: 'firstName',
  lastName: 'lastName',
  luggage: 'luggage',
  dateOfBirth,
  gender,
  travelClass,
  ssrs,
  infant,
  checkedInOnFlights: () => [],
}
